
import React from 'react';
import { mapStreamViewModel } from 'src/js/pages/streaming/stream/stream-view-model-mapper';
import { StreamResponse, StreamShaping } from 'src/js/pages/streaming/stream/stream-models';
import { t } from 'src/js/util/test-util';
import { StreamStatistics } from '../../pages/streaming/stream/stream-statistics';

const whipStreamStarted: StreamResponse = {
    "info": {
        "name": "",
        "id": 1,
        "pmtPidAutoAssigned": false,
        "pcrPidAutoAssigned": false,
        "programNumberAutoAssigned": false,
        "encapsulation": 128,
        "userData": "",
        "url": "https://my-whip-test-project-y2y8lk0s.whip.livekit.cloud/w",
        "bearerToken": "CBMxmxgDp8D8",
        "port": 0,
        "networkInterface": "eth0",
        "video": [
            {
                "id": 0,
                "name": "Video Encoder 0",
                "pid": 0,
                "autoassigned": false
            }
        ],
        "audio": [
            {
                "id": 0,
                "name": "Audio Encoder 0",
                "pid": 0,
                "interface": 1,
                "layout": 0,
                "channels": 2,
                "autoassigned": false
            }
        ],
        "metadata": [],
        "scte": [],
        "sap": {},
        "mtu": 1496,
        "tos": "0x80",
        "ttl": 64,
    "shaping": StreamShaping.VBR,
        "overheadPercentage": 15,
        "bandwithEstimate": 1160,
        "metadataBandwidth": 0,
        "metadataBandwidthAutoAssigned": false,
        "encryption": false,
        "idleCells": false,
        "delayedAudio": false,
        "metadataEncapsulation": 0,
        "persistent": true,
        "stillImage": ""
    },
    "stats": {
        "state": 1,
        "stateString": "STREAMING",
        "uptime": "11s",
        "lastReset": "Never",
        "sentPackets": "9,799",
        "sentBytes": "6,135,417",
        "bitrate": "1,285 kbps",
        "bitrateInKbps": 1285,
        "unsentPackets": "0",
        "unsentBytes": "0",
        "whipLocalPort": 5630,
        "whipRemotePort": 55280,
        "whipFullIntraRequests": "0",
        "whipPictureLoss": "4",
        "whipNACK": "0",
        "whipPacketLoss": "0",
        "whipRTT": "16 ms",
        "whipJitter": "8 ms",
        "programNumber": "1",
        "pcrPid": "33",
        "fecRtp": 0
    }
};

const whipStreamStopped: StreamResponse = {
  "info": {
    "name": "",
    "id": 1,
    "type": 1,
    "encapsulation": 128,
    "userData": "",
    "url": "https://my-whip-test-project-y2y8lk0s.whip.livekit.cloud/w",
    "bearerToken": "CBMxmxgDp8D8",
    "port": 0,
    "networkInterface": "eth0",
    "video": [
      {
        "id": 0,
        "name": "Video Encoder 0",
        "pid": 0,
        "autoassigned": false
      }
    ],
    "audio": [
      {
        "id": 0,
        "name": "Audio Encoder 0",
        "pid": 0,
        "interface": 1,
        "layout": 0,
        "channels": 2,
        "autoassigned": false
      }
    ],
    "metadata": [],
    "scte": [],
    "sap": {

    },
    "mtu": 1496,
    "tos": "0x80",
    "ttl": 64,
    "shaping": "vbr" as any,
    "overheadPercentage": 15,
    "bandwithEstimate": 1160,
    "metadataBandwidth": 0,
    "metadataBandwidthAutoAssigned": false,
    "encryption": false,
    "fec": 0,
    "idleCells": false,
    "delayedAudio": false,
    "metadataEncapsulation": 0,
    "persistent": true,
    "stillImage": ""
  },
  "stats": {
    "state": 0,
    "stateString": "STOPPED",
    "uptime": "48m34s",
    "lastReset": "Never",
    "sentPackets": "0",
    "sentBytes": "0",
    "bitrate": "0 kbps",
    "bitrateInKbps": 0,
    "unsentPackets": "0",
    "unsentBytes": "0"
  } as any
};


const whipStreamError: StreamResponse = {
            "info": {
                "name": "WHIP to QA Server",
                "id": 1,
                "type": 1,
                "encapsulation": 128,
                "userData": "",
                "url": "https://invalid-url-eqa-livekit-whip.eqa.haivision.com/w",
                "bearerToken": "Qkn535tEjxR8",
                "port": 0,
                "networkInterface": "",
                "video": [
                    {
                        "id": 0,
                        "name": "Video Encoder 0",
                        "pid": 0,
                        "autoassigned": false
                    }
                ],
                "audio": [
                    {
                        "id": 0,
                        "name": "Audio Encoder 0",
                        "pid": 0,
                        "interface": 1,
                        "layout": 0,
                        "channels": 2,
                        "autoassigned": false
                    }
                ],
                "metadata": [],
                "scte": [],
                "sap": {},
                "mtu": 1496,
                "tos": "0x80",
                "ttl": 64,
                "shaping": "vbr" as any,
                "overheadPercentage": 15,
                "bandwithEstimate": 6259,
                "metadataBandwidth": 0,
                "metadataBandwidthAutoAssigned": false,
                "encryption": false,
                "fec": 0,
                "idleCells": false,
                "delayedAudio": false,
                "metadataEncapsulation": 0,
                "persistent": true,
                "stillImage": ""
            },
            "stats": {
                "state": 2,
                "stateString": "FAILED",
                "uptime": "30m48s",
                "lastReset": "Never",
                "sentPackets": "0",
                "sentBytes": "0",
                "bitrate": "0 kbps",
                "bitrateInKbps": 0,
                "unsentPackets": "0",
                "unsentBytes": "0",
                "whipLastError": "-40 (connection: error sending request for url (https://invalid-u...)",
                "whipLastErrorOccured": "0s ago"
            } as any
        };

const WhipStatsDemo: React.FC = () => {
  const viewModel = mapStreamViewModel(whipStreamStarted, t);
  const viewModelStopped = mapStreamViewModel(whipStreamStopped, t);
  const viewModelError = mapStreamViewModel(whipStreamError, t);
  return (
    <div style={{ maxWidth: 900, margin: '2rem auto', padding: 24, backgroundColor: '#25262c' }}>
      <h2 style={{color:'white'}}>WHIP Stream Statistics Test</h2>
      <br/>
      <StreamStatistics
        parent="STREAM"
        model={viewModelStopped}
      />
      <br/>
      <StreamStatistics
        parent="STREAM"
        model={viewModel}
      />
      <br/>
      <StreamStatistics
        parent="STREAM"
        model={viewModelError}
      />
    </div>
  );
};

export default WhipStatsDemo;
